import script from "./privacy.vue?vue&type=script&setup=true&lang=ts"
export * from "./privacy.vue?vue&type=script&setup=true&lang=ts"

import "./privacy.vue?vue&type=style&index=0&id=356fdcb2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-356fdcb2"]])

export default __exports__